<template>
    <div class="stats-container">
        <div class="stat"
             v-for="(stat, index) of stats"
             :key="index"
             v-b-tooltip.hover
             :title="stat.tooltip">
            <div class="data" v-if="$route.path === '/transactions'">
                {{ stat.data.slice(0, 2) }} {{ (+stat.data.slice(2)).toLocaleString('en-US') }}
            </div>
            <div class="data" v-else>
                {{ stat.data }}
            </div>
            <div class="label">
                {{ stat.label }}
            </div>
        </div>
        <div v-if="$route.path === '/contacts'" class="d-flex flex-grow-1 justify-content-end align-items-center">
           <div>
               <button @click="emailAll" class="primary-btn contact px-4">Email All Contacts</button>
           </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: 'Stats',
        computed: {
            ...mapGetters(['stats']),
        },
        methods: {
            ...mapActions(['openModal']),
            emailAll() {
                this.openModal({ modalName: 'ContactsAllEmailModal', options: { width: '680px' }});
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/colors";

    .contact {
        @media (max-width: 380px) {
        padding-top: 40px;
        padding-bottom: 40px;
        }
    }
    .stats-container {
        margin: 20px 0;
        display: flex;
        font-family: Asap;
        .stat {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 50px;
            min-width: 180px;
            padding: 5px 15px;
            background: $White;
            border-radius: 23px;
            box-shadow: 0 0 20px 0 rgba(176, 186, 197, 0.15);
            &:not(:last-child) {
                margin-right: 20px;
            }
            @media screen and (max-width: 680px) {
                max-width: 180px;
                width: max-content;
                min-width: 28%;
                flex-wrap: wrap;
            }
            @media screen and (max-width: 568px) {
                height: 55px;
                flex-direction: column;
                flex-wrap: nowrap;
                padding: 8px 15px;
                border-radius: 25px;
            }

            .data {
                margin: 0 5px;
                font-size: 24px;
                line-height: 0.88;
                color: $Dark;
            }
            .label {
                margin: 0 5px;
                font-size: 16px;
                color: $WhiteGrey;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/main/Stats.vue